module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "deal"
    }
  }, [_c('div', {
    staticClass: "entity-card"
  }, [(_vm.deal) ? _c('div', {
    staticClass: "md-layout md-gutter entity-card-head"
  }, [_c('div', {
    staticClass: "md-layout-item md-layout common"
  }, [(_vm.deal.first_freight && _vm.deal.first_freight.traking_number) ? _c('div', {
    staticClass: "md-layout-item entity-head-left"
  }, [_c('div', {
    staticClass: "traking-number"
  }, [_vm._v(_vm._s(_vm.deal.first_freight.traking_number))]), (_vm.blockDeal) ? _c('div', {
    staticClass: "status"
  }, [(_vm.isIssusedToClient) ? _c('div', {
    staticClass: "deny"
  }, [_vm._v("Груз выдан клиенту!")]) : _c('div', {
    staticClass: "deny"
  }, [_vm._v("Изменение заявки заблокированно")])]) : _vm._e(), (!_vm.blockDeal && _vm.blockCustomers) ? _c('div', {
    staticClass: "status"
  }, [_c('div', {
    staticClass: "deny"
  }, [_vm._v("Изменение контрагентов заблокированно")])]) : _c('div', {
    staticClass: "status"
  }, [(_vm.deal.first_freight && _vm.deal.first_freight.currenttracking && _vm.deal.first_freight.currenttracking.status) ? _c('span', {
    style: ('color: ' + _vm.deal.first_freight.currenttracking.status.color),
    attrs: {
      "title": _vm.deal.first_freight.currenttracking.status.name
    }
  }, [_vm._v(_vm._s(_vm.deal.first_freight.currenttracking.status.name))]) : _c('span', {
    attrs: {
      "title": "Не установлен"
    }
  }, [_vm._v("Не установлен")])])]) : _vm._e(), _c('div', {
    staticClass: "md-layout-item entity-head-right"
  }, [_c('div', {
    staticClass: "date"
  }, [(_vm.deal.id && _vm.deal.created_at) ? _c('span', [_vm._v(_vm._s('Создана: ' + _vm.moment(_vm.deal.created_at).tz(_vm.$root.userTimezone).format('DD.MM.YYYY HH:mm')))]) : _vm._e(), (_vm.deal.id && _vm.deal.updated_at) ? _c('span', [_vm._v(_vm._s('Обновлена: ' + _vm.moment(_vm.deal.updated_at).tz(_vm.$root.userTimezone).format('DD.MM.YYYY HH:mm')))]) : _vm._e()]), (!_vm.blockDeal) ? _c('md-button', {
    staticClass: "md-primary md-icon-button md-dense close small",
    on: {
      "click": _vm.save
    }
  }, [_c('md-icon', [_vm._v("check")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Сохранить")])], 1) : _vm._e(), _c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    on: {
      "click": _vm.back
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Отменить")])], 1)], 1)]), _c('div', {
    staticClass: "md-layout-item md-layout prices"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-65"
  }, [(_vm.deal && _vm.deal.first_freight) ? _c('div', {
    staticClass: "price-debtors"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.deal.id && _vm.deal.first_freight.full_price) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.customPrice),
      expression: "!customPrice"
    }],
    ref: "fullPrice",
    staticClass: "price",
    class: {
      'custom': (_vm.deal.first_freight && !!_vm.deal.first_freight.custom_price_active)
    }
  }, [_c('div', {
    staticClass: "price-value"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Цена:")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.deal.first_freight.price)) + " руб.")])]), _c('md-button', {
    staticClass: "md-icon-button md-dense close small full-price-btn recalc",
    attrs: {
      "disabled": !_vm.canEditPrice
    },
    on: {
      "click": _vm.recalcPrice
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  }), _c('md-tooltip', {
    attrs: {
      "md-direction": "top",
      "md-delay": "500"
    }
  }, [_vm._v("Пересчитать цену")])], 1), (_vm.deal && _vm.deal.id) ? _c('z-tool-menu', {
    attrs: {
      "active": _vm.showFullPrice,
      "left": "left"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(scope) {
        return [_c('md-button', {
          staticClass: "md-icon-button md-dense close small full-price-btn",
          on: {
            "click": _vm.toggleFullPrice
          }
        }, [_c('i', {
          staticClass: "fas fa-chevron-down"
        }), _c('md-tooltip', {
          attrs: {
            "md-direction": "bottom",
            "md-delay": "500"
          }
        }, [_vm._v("Показать детализированную цену")])], 1)]
      }
    }])
  }, [(_vm.deal && _vm.deal.id) ? _c('price-list', {
    attrs: {
      "payers": _vm.selectablePayers,
      "storage": _vm.storage,
      "deal": _vm.deal,
      "freight": _vm.deal.first_freight,
      "payer-id": parseInt(_vm.deal.payer_id),
      "blocked": !_vm.canEditPrice
    },
    on: {
      "recalc": _vm.recalcStoragePrice,
      "update": _vm.setPrice
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal && _vm.deal.first_freight && _vm.customPrice),
      expression: "deal && deal.first_freight && customPrice"
    }],
    staticClass: "price input-price-container"
  }, [_c('div', {
    staticClass: "input-price"
  }, [_c('label', [_vm._v("Цена:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deal.first_freight.price),
      expression: "deal.first_freight.price"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'decimal': [2, '.'],
        min_value: (_vm.isUserAdmin ? 0 : 1)
      }),
      expression: "{'decimal': [2, '.'], min_value: (isUserAdmin ? 0 : 1)}"
    }],
    ref: "customprice",
    staticClass: "input-price",
    attrs: {
      "type": "number",
      "name": "freight_price",
      "id": "freight_price",
      "data-vv-name": "freight_price",
      "data-vv-scope": "price",
      "data-vv-as": " ",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.deal.first_freight.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deal.first_freight, "price", $event.target.value)
      }
    }
  }), _c('span', [_vm._v("руб.")]), (_vm.customPrice && !!parseInt(_vm.deal.first_freight.custom_price_active)) ? _c('md-button', {
    staticClass: "md-accent md-icon-button md-dense close small",
    on: {
      "click": _vm.unsetCustomPrice
    }
  }, [_c('md-icon', [_vm._v("delete")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "top",
      "md-delay": "500"
    }
  }, [_vm._v("Удалить")])], 1) : _vm._e(), (_vm.customPrice) ? _c('md-button', {
    staticClass: "md-primary md-icon-button md-dense close small",
    on: {
      "click": _vm.setCustomPrice
    }
  }, [_c('md-icon', [_vm._v("check")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "top",
      "md-delay": "500"
    }
  }, [_vm._v("Применить")])], 1) : _vm._e(), (_vm.customPrice) ? _c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    on: {
      "click": _vm.hideCustomPrice
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "top",
      "md-delay": "500"
    }
  }, [_vm._v("Отменить")])], 1) : _vm._e()], 1), (_vm.errors.first('price.freight_price')) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('price.freight_price')))]) : _vm._e()])]), (_vm.deal && _vm.deal.first_freight && _vm.deal.first_freight) ? _c('ZDealStatusChanger', {
    attrs: {
      "deal-id": _vm.deal.id,
      "status-request": "status-request",
      "disabled": !!(_vm.deal.first_freight.route_lists && _vm.deal.first_freight.route_lists.length)
    },
    on: {
      "update": _vm.onDealStatusUpdate
    },
    model: {
      value: (_vm.deal.status_id),
      callback: function($$v) {
        _vm.$set(_vm.deal, "status_id", $$v)
      },
      expression: "deal.status_id"
    }
  }) : _vm._e(), (_vm.deal && _vm.deal.first_freight && _vm.deal.first_freight) ? _c('ZDealIssueStatusChanger', {
    attrs: {
      "deal-id": _vm.deal.id,
      "disabled-recalc": _vm.blockDeal,
      "payers": _vm.selectablePayers
    },
    on: {
      "recalc": _vm.recalcDebtors
    },
    model: {
      value: (_vm.deal.status_issue_id),
      callback: function($$v) {
        _vm.$set(_vm.deal, "status_issue_id", $$v)
      },
      expression: "deal.status_issue_id"
    }
  }) : _vm._e()], 1) : _vm._e()]), (_vm.deal.id && !_vm.dirtyForOperations && _vm.paymentMethods) ? _c('div', {
    staticClass: "md-layout-item md-size-35 md-alignment-center"
  }, [_c('z-input-finance-operation', {
    attrs: {
      "deal-id": parseInt(_vm.deal.id),
      "company-id": parseInt(_vm.deal.executor_company_id),
      "price": (_vm.deal.first_freight ? parseFloat(_vm.deal.first_freight.price) : 0),
      "payers-price": ((_vm.deal.first_freight && _vm.deal.first_freight.full_price && _vm.deal.first_freight.full_price.payers) ? _vm.deal.first_freight.full_price.payers : {}),
      "required-full-price": true,
      "payers": _vm.selectablePayers,
      "payment-methods": _vm.paymentMethods,
      "dirty": _vm.isDirty.operations,
      "disabled": _vm.blockDeal
    },
    on: {
      "save": _vm.saveFromOperations,
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "operations", $event)
      },
      "remove": _vm.recalcDebt
    },
    model: {
      value: (_vm.deal.operations),
      callback: function($$v) {
        _vm.$set(_vm.deal, "operations", $$v)
      },
      expression: "deal.operations"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "md-layout-item md-size-35 md-alignment-center"
  }, [(_vm.dirtyForOperations) ? _c('div', {
    staticClass: "operation-dirty-error"
  }, [_c('span', [_vm._v("Добавление платежей доступно после")]), _c('span', [_vm._v("сохранения внесённых изменений")])]) : _vm._e()])])]) : _vm._e(), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressDealForm),
      expression: "progressDealForm"
    }],
    staticClass: "entity-card-body"
  }, [_c('flex-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": "min",
      "prevent-input": "prevent-input"
    },
    on: {
      "change": _vm.changeActiveTab
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-customers'),
      expression: "activeTab == 'tab-customers'"
    }],
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Отправитель")]), _c('sender', {
    ref: "sender",
    attrs: {
      "customers-ul": _vm.customersUL,
      "customers-fl": _vm.customersFL,
      "block": (_vm.blockDeal || _vm.blockCustomers),
      "search-by-inn-callback": _vm.searchCustomerByInn,
      "break-customer-callback": _vm.breakCustomer,
      "search-customer-by-passport-callback": _vm.searchCustomerByPassport,
      "dirty": _vm.isDirty.sender,
      "isUserHasHighPermission": _vm.isUserHasHighPermission,
      "isUserAgent": _vm.isUserAgent,
      "isUserAdmin": _vm.isUserAdmin,
      "isUserManager": _vm.isUserManager,
      "isDealCanceled": _vm.isDealCanceled,
      "isIssueToTransfer": _vm.isIssueToTransfer,
      "isEnteredToStock": _vm.isEnteredToStock,
      "isIssusedToClient": _vm.isIssusedToClient
    },
    on: {
      "change-contacts": _vm.changeContacts,
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "sender", $event)
      }
    },
    model: {
      value: (_vm.deal.sender),
      callback: function($$v) {
        _vm.$set(_vm.deal, "sender", $$v)
      },
      expression: "deal.sender"
    }
  }), _c('delivery-from', {
    ref: "deliveryFrom",
    attrs: {
      "isUserAgentForm": _vm.isUserAgentForm,
      "block": (_vm.blockDeal || _vm.blockCustomers),
      "suggest-address-callback": _vm.suggestAddress,
      "dirty": _vm.isDirty.from,
      "payers": _vm.selectablePayers,
      "can-edit-price": _vm.canEditPrice,
      "isUserHasHighPermission": _vm.isUserHasHighPermission,
      "isUserAgent": _vm.isUserAgent,
      "isUserAdmin": _vm.isUserAdmin,
      "isUserManager": _vm.isUserManager,
      "isDealCanceled": _vm.isDealCanceled,
      "isIssueToTransfer": _vm.isIssueToTransfer,
      "isEnteredToStock": _vm.isEnteredToStock,
      "isIssusedToClient": _vm.isIssusedToClient
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "from", $event)
      }
    },
    model: {
      value: (_vm.deal),
      callback: function($$v) {
        _vm.deal = $$v
      },
      expression: "deal"
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Получатель")]), _c('recipient', {
    ref: "recipient",
    attrs: {
      "customers-ul": _vm.customersUL,
      "customers-fl": _vm.customersFL,
      "block": (_vm.blockDeal || _vm.blockCustomers),
      "search-by-inn-callback": _vm.searchCustomerByInn,
      "break-customer-callback": _vm.breakCustomer,
      "search-customer-by-passport-callback": _vm.searchCustomerByPassport,
      "dirty": _vm.isDirty.recipient,
      "isUserHasHighPermission": _vm.isUserHasHighPermission,
      "isUserAgent": _vm.isUserAgent,
      "isUserAdmin": _vm.isUserAdmin,
      "isUserManager": _vm.isUserManager,
      "isDealCanceled": _vm.isDealCanceled,
      "isIssueToTransfer": _vm.isIssueToTransfer,
      "isEnteredToStock": _vm.isEnteredToStock,
      "isIssusedToClient": _vm.isIssusedToClient
    },
    on: {
      "change-contacts": _vm.changeContacts,
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "recipient", $event)
      }
    },
    model: {
      value: (_vm.deal.recipient),
      callback: function($$v) {
        _vm.$set(_vm.deal, "recipient", $$v)
      },
      expression: "deal.recipient"
    }
  }), _c('delivery-to', {
    ref: "deliveryTo",
    attrs: {
      "block": (_vm.blockDeal || _vm.blockCustomers),
      "suggest-address-callback": _vm.suggestAddress,
      "dirty": _vm.isDirty.to,
      "payers": _vm.selectablePayers,
      "can-edit-price": _vm.canEditPrice,
      "isUserHasHighPermission": _vm.isUserHasHighPermission,
      "isUserAgent": _vm.isUserAgent,
      "isUserAdmin": _vm.isUserAdmin,
      "isUserManager": _vm.isUserManager,
      "isDealCanceled": _vm.isDealCanceled,
      "isIssueToTransfer": _vm.isIssueToTransfer,
      "isEnteredToStock": _vm.isEnteredToStock,
      "isIssusedToClient": _vm.isIssusedToClient
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "to", $event)
      }
    },
    model: {
      value: (_vm.deal),
      callback: function($$v) {
        _vm.deal = $$v
      },
      expression: "deal"
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Прочие данные")]), _c('applicant', {
    ref: "applicant",
    attrs: {
      "deal": _vm.deal,
      "block": (_vm.blockDeal || _vm.blockCustomers || _vm.isIssueToTransfer || _vm.isEnteredToStock),
      "dirty": _vm.isDirty.applicant
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "applicant", $event)
      }
    },
    model: {
      value: (_vm.deal.applicant_id),
      callback: function($$v) {
        _vm.$set(_vm.deal, "applicant_id", $$v)
      },
      expression: "deal.applicant_id"
    }
  }), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "С НДС / без НДС",
      "required": true,
      "name": "executor_company_id",
      "id": "executor_company_id",
      "error": _vm.errors.first('executor_company_id') || (_vm.isDealHasInvoice || _vm.isDealHasAct ? 'У заявки создана Счёт-фактура или Акт, изменение исполнителя невозможно' : null),
      "disabled": (_vm.blockDeal || _vm.blockCustomers || _vm.isDealCompletePayment || !!_vm.isDealHasInvoice || !!_vm.isDealHasAct),
      "inline": "inline",
      "dirty": _vm.isDirty.executor
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "executor", $event)
      }
    },
    model: {
      value: (_vm.deal.executor_company_id),
      callback: function($$v) {
        _vm.$set(_vm.deal, "executor_company_id", $$v)
      },
      expression: "deal.executor_company_id"
    }
  }, _vm._l((_vm.companies), function(company) {
    return _c('option', {
      key: company.id,
      attrs: {
        "disabled": parseInt(company.active) == 0 && !_vm.isUserAdmin
      },
      domProps: {
        "value": company.id
      }
    }, [_vm._v(_vm._s(((parseInt(company.nds)) ? ("с НДС " + (company.nds_value) + "%") : 'без НДС') + ' (' + company.name + ')'))])
  }))], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-100"
  }, [_c('div', {
    staticClass: "deal__payers-actions"
  }, [_c('div', {
    staticClass: "md-subheading"
  }, [_vm._v("Плательщик")]), (_vm.deal.id && _vm.deal.id != 'new' && !_vm.blockDeal && _vm.deal.payer && _vm.deal.payer.id) ? _c('z-button', {
    attrs: {
      "square": "square"
    },
    on: {
      "click": _vm.addPayer
    }
  }, [_c('md-icon', [_vm._v("add")])], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "deal__payers-container"
  }, [_c('toggle-card', {
    staticClass: "deal__payers-item",
    attrs: {
      "heading": "Основной плательщик",
      "visibility": true
    }
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Плательщик",
      "name": "payer_who",
      "id": "payer_who",
      "required": true,
      "inline": "inline",
      "error": _vm.errors.first('payer_who'),
      "data-vv-as": ' ',
      "disabled": (_vm.blockDeal || _vm.blockCustomers || _vm.isDealCompletePayment || (_vm.aviablesPayerTypeLength === 1 && _vm.deal.payer_type == 3)),
      "dirty": _vm.isDirty.payer
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "payer", $event)
      }
    },
    model: {
      value: (_vm.deal.payer_type),
      callback: function($$v) {
        _vm.$set(_vm.deal, "payer_type", $$v)
      },
      expression: "deal.payer_type"
    }
  }, _vm._l((_vm.payerType), function(item) {
    return _c('option', {
      attrs: {
        "disabled": item.disabled
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "payment-method",
    attrs: {
      "label": "Способ оплаты",
      "name": "payment_method_id",
      "id": "payment_method_id",
      "required": true,
      "inline": "inline",
      "data-vv-name": "payment_method_id",
      "data-vv-as": ' ',
      "error": _vm.errors.first('payment_method_id'),
      "disabled": (_vm.blockDeal || _vm.blockCustomers || !!(_vm.hasOperationsByPayer(_vm.deal.payer ? _vm.deal.payer.id : null) && !_vm.isUserAdmin)),
      "dirty": _vm.isDirty.paymentType
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "paymentType", $event)
      }
    },
    model: {
      value: (_vm.deal.payment_method_id),
      callback: function($$v) {
        _vm.$set(_vm.deal, "payment_method_id", $$v)
      },
      expression: "deal.payment_method_id"
    }
  }, _vm._l((_vm.paymentMethods), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('payer', {
    ref: "payer",
    attrs: {
      "deal": _vm.deal,
      "who": _vm.deal.payer_type,
      "customers-ul": _vm.payersUL,
      "customers-fl": _vm.payersFL,
      "block": (_vm.blockDeal || _vm.blockCustomers || _vm.isDealCompletePayment),
      "search-by-inn-callback": _vm.searchCustomerByInn,
      "break-customer-callback": _vm.breakCustomer,
      "search-customer-by-passport-callback": _vm.searchCustomerByPassport,
      "dirty": _vm.isDirty.payer
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "payer", $event)
      }
    },
    model: {
      value: (_vm.deal.payer),
      callback: function($$v) {
        _vm.$set(_vm.deal, "payer", $$v)
      },
      expression: "deal.payer"
    }
  })], 1), _vm._l((_vm.deal.payers), function(payer, i) {
    return _c('toggle-card', {
      key: ('payer-' + i),
      staticClass: "deal__payers-item",
      attrs: {
        "heading": ('Плательщик ' + (i + 2)),
        "visibility": payer.visibility
      }
    }, [_c('template', {
      slot: "actions"
    }, [(!(_vm.blockDeal || _vm.blockCustomers || !!_vm.hasOperationsByPayer(payer.id))) ? _c('z-button', {
      attrs: {
        "accent": "accent",
        "square": "square"
      },
      on: {
        "click": function($event) {
          _vm.removePayer($event, i)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _c('z-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": "Плательщик",
        "inline": "inline",
        "required": true,
        "name": ('payer_who-' + i),
        "id": ('payer_who-' + i),
        "error": _vm.errors.first(('payer_who-' + i)),
        "data-vv-as": ' ',
        "disabled": (_vm.blockDeal || _vm.blockCustomers || _vm.isDealCompletePayment || (_vm.aviablesPayerTypeLength === 1 && payer.who == 3) || !!_vm.hasOperationsByPayer(payer.id)) && !_vm.isUserAdmin,
        "dirty": _vm.isDirty.payer
      },
      on: {
        "update:dirty": function($event) {
          _vm.$set(_vm.isDirty, "payer", $event)
        }
      },
      model: {
        value: (payer.who),
        callback: function($$v) {
          _vm.$set(payer, "who", $$v)
        },
        expression: "payer.who"
      }
    }, _vm._l((_vm.payerType), function(item) {
      return _c('option', {
        attrs: {
          "disabled": item.disabled
        },
        domProps: {
          "value": item.value
        }
      }, [_vm._v(_vm._s(item.label))])
    })), (payer && payer.value && payer.value.pivot) ? _c('z-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "payment-method",
      attrs: {
        "label": "Способ оплаты",
        "name": ('payment_method_id-' + i),
        "id": ('payment_method_id-' + i),
        "required": true,
        "inline": "inline",
        "data-vv-as": ' ',
        "error": _vm.errors.first(('payment_method_id-' + i)),
        "disabled": (_vm.blockDeal || _vm.blockCustomers || !!_vm.hasOperationsByPayer(payer.id)) && !_vm.isUserAdmin,
        "dirty": _vm.isDirty.payer
      },
      on: {
        "update:dirty": function($event) {
          _vm.$set(_vm.isDirty, "payer", $event)
        }
      },
      model: {
        value: (payer.value.pivot.payment_method_id),
        callback: function($$v) {
          _vm.$set(payer.value.pivot, "payment_method_id", $$v)
        },
        expression: "payer.value.pivot.payment_method_id"
      }
    }, _vm._l((_vm.paymentMethods), function(item) {
      return _c('option', {
        domProps: {
          "value": item.id
        }
      }, [_vm._v(_vm._s(item.name))])
    })) : _vm._e(), (_vm.deal.payers && _vm.deal.payers.length) ? _c('payer', {
      ref: "payer-item",
      refInFor: true,
      attrs: {
        "deal": _vm.deal,
        "who": payer.who,
        "customers-ul": _vm.payersUL,
        "customers-fl": _vm.payersFL,
        "block": (_vm.blockDeal || _vm.blockCustomers || _vm.isDealCompletePayment || !!_vm.hasOperationsByPayer(payer.id)),
        "search-by-inn-callback": _vm.searchCustomerByInn,
        "break-customer-callback": _vm.breakCustomer,
        "search-customer-by-passport-callback": _vm.searchCustomerByPassport,
        "dirty": _vm.isDirty.payer
      },
      on: {
        "update:dirty": function($event) {
          _vm.$set(_vm.isDirty, "payer", $event)
        }
      },
      model: {
        value: (payer.value),
        callback: function($$v) {
          _vm.$set(payer, "value", $$v)
        },
        expression: "payer.value"
      }
    }) : _vm._e()], 2)
  })], 2)]), _c('freight', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-freight'),
      expression: "activeTab == 'tab-freight'"
    }],
    ref: "freight",
    attrs: {
      "deal": _vm.deal,
      "block": (_vm.blockDeal),
      "dirty": _vm.isDirty.freight,
      "payers": _vm.selectablePayers,
      "fromLuw": _vm.fromLuw,
      "toLuw": _vm.toLuw,
      "isDealDirty": _vm.dirty,
      "isUserHasHighPermission": _vm.isUserHasHighPermission,
      "isUserAgent": _vm.isUserAgent,
      "isUserAdmin": _vm.isUserAdmin,
      "isUserManager": _vm.isUserManager,
      "isDealCanceled": _vm.isDealCanceled,
      "isIssueToTransfer": _vm.isIssueToTransfer,
      "isEnteredToStock": _vm.isEnteredToStock,
      "isIssusedToClient": _vm.isIssusedToClient
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.isDirty, "freight", $event)
      }
    },
    model: {
      value: (_vm.deal.first_freight),
      callback: function($$v) {
        _vm.$set(_vm.deal, "first_freight", $$v)
      },
      expression: "deal.first_freight"
    }
  }), _c('ZFreightTracking', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.activeTab == 'tab-tracking')),
      expression: "(activeTab == 'tab-tracking')"
    }],
    ref: "tracking",
    attrs: {
      "deal": _vm.deal,
      "freight": _vm.deal.first_freight,
      "load": (_vm.activeTab == 'tab-tracking'),
      "block": _vm.blockDeal
    },
    on: {
      "change": _vm.changeCurrentTracking,
      "change-deal-status": _vm.onDealUpdate
    }
  }), (_vm.deal && _vm.deal.id && _vm.deal.id !== 'new') ? _c('docs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-docs'),
      expression: "activeTab == 'tab-docs'"
    }],
    attrs: {
      "deal": _vm.deal,
      "load": (_vm.activeTab == 'tab-docs'),
      "freight": _vm.deal.first_freight,
      "block": _vm.blockDeal,
      "finance": _vm.deal.operations
    },
    on: {
      "update": _vm.updateDocuments
    }
  }) : _vm._e(), _c('tasks', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tab-tasks'),
      expression: "activeTab == 'tab-tasks'"
    }],
    attrs: {
      "load": _vm.activeTab == 'tab-tasks',
      "deal": _vm.deal
    }
  }), (_vm.deal.id && _vm.activeTab == 'tab-comments') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('comments-and-logs', {
    attrs: {
      "entity_id": _vm.deal.id,
      "entity": "deals",
      "module": "deals"
    }
  })], 1) : _vm._e()], 1), (_vm.isUserAgent || _vm.isUserAdmin) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticketsPrintData.trackingNumber),
      expression: "ticketsPrintData.trackingNumber"
    }],
    staticClass: "entity-card-footer"
  }, [((_vm.ticketsPrintData.trackingNumber && parseInt(_vm.ticketsPrintData.seatsNumber) > 0 && _vm.ticketsPrintData.sender && _vm.ticketsPrintData.recipient)) ? _c('ticket-print', {
    ref: "ticketprint",
    attrs: {
      "printers": _vm.printers,
      "trackingNumber": _vm.ticketsPrintData.trackingNumber,
      "date": _vm.ticketsPrintData.date,
      "fromCity": _vm.ticketsPrintData.fromCity,
      "toCity": _vm.ticketsPrintData.toCity,
      "fromAddress": _vm.ticketsPrintData.fromAddress,
      "toAddress": _vm.ticketsPrintData.toAddress,
      "seatsNumber": parseInt(_vm.ticketsPrintData.seatsNumber),
      "sender": _vm.ticketsPrintData.sender,
      "recipient": _vm.ticketsPrintData.recipient,
      "temperature-regime": _vm.ticketsPrintData.tempReg
    }
  }) : _vm._e(), (_vm.isUserAgent && _vm.deal && _vm.deal.id && _vm.deal.first_freight && _vm.deal.first_freight.from_stock_signature) ? _c('div', {
    staticClass: "print-btn",
    on: {
      "click": function($event) {
        _vm.printDoc(_vm.deal.id, 'stock_note')
      }
    }
  }, [_vm._v("Складская записка")]) : _vm._e(), (_vm.isUserAgent) ? _c('div', {
    staticClass: "shipment md-caption bottom"
  }, [(!_vm.canIssue) ? _c('div', {
    staticClass: "deny"
  }, [_vm._v("Выдача запрешена")]) : _vm._e(), (_vm.canIssue) ? _c('md-button', {
    staticClass: "md-dense md-accent close small",
    on: {
      "click": _vm.issue
    }
  }, [_vm._v("Выдать груз")]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96ba9bb8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/Deal.vue
// module id = 1220
// module chunks = 0